import Vue from 'vue';
import { mapGetters } from 'vuex';

import Multiselect from 'vue-multiselect';
import Treeselect from '@riophae/vue-treeselect';
import FileUpload from 'vue-upload-component';
import Cropper from 'cropperjs';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import buttonLoader from '@/components/button';
import uploadImageWindow from '@/components/uploadImageWindow/index.vue';

import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

import { DEFAULT_IMAGE, REGEX } from '@/utils/const';

export default Vue.extend({
  components: {
    Multiselect,
    Treeselect,
    FileUpload,
    uploadImageWindow,
    buttonLoader,
    preloader,
    'tool-tip': () => import('@/components/tooltip/index.vue'),
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,

      userData: {
        FavoriteLanguagePaars: [],
        UserCompanyData: null,
      },
      titles: {},

      sourceLanguageList: [],
      targetLanguageList: [],
      textCategoryList: [],
      evaluationMethodsList: [],
      qaMethodsList: [],
      catToolsList: [],

      countries: [],

      optionsTree: [],
      loading: false,
      imgFiles: [],
      editFile: false,
      cropper: false,
      urlRegex: REGEX.urlRegex,
      emailRegex: REGEX.emailRegex,
      userNameRegex: REGEX.userNameRegex,
      gender: [
        'male',
        'female',
        'N',
      ],

      statusCompany: [{
        ID: 'active',
        Name: 'active',
      }, {
        ID: 'inactive',
        Name: 'inactive',
      }, {
        ID: 'potential',
        Name: 'potential',
      }],

      showLimit: 3,
      showMore: false,
      load: true,

      copyNEmail: false,
      notifacationEmail: '',
    };
  },
  watch: {
    editFile (value) {
      if (value) {
        this.$nextTick(() => {
          if (!this.$refs.editImage) {
            return;
          }
          const cropper = new Cropper(this.$refs.editImage, {
            aspectRatio: 1 / 1,
            viewMode: 1,
          });
          this.cropper = cropper;
        });
      } else {
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  mounted () {
    this.load = true;
    Promise.all([
      Promise.all([
        this.getAllTitles(),
        this.getCountries(),
        this.getLanguages(),
        this.getUserData(),
      ]).then(() => {
        this.holderUserResponse();
      }),
      this.getIndustryMethods(),
      this.getDocumentType(),
      this.getQaMethods(),
      this.getCatTools(),
      this.getEvaluationMethods(),
    ]).then(() => {
      this.load = false;
    });
  },
  methods: {
    selectItem (name, event) {
      if (name === 'source_languages' && this.userData.TargetLanguages !== null) {
        this.userData.TargetLanguages.forEach((item) => {
          this.userData.FavoriteLanguagePaars.push(this.setNewPaars(event.ID, item.ID));
        });
      }
      if (name === 'target_languages' && this.userData.SourceLanguages !== null) {
        this.userData.SourceLanguages.forEach((item) => {
          this.userData.FavoriteLanguagePaars.push(this.setNewPaars(item.ID, event.ID));
        });
      }
      this.addLanguageParams();
    },

    removeItem (name, event) {
      if (name === 'source_languages') {
        this.userData.FavoriteLanguagePaars = this.userData.FavoriteLanguagePaars.filter((item) => item.SourceLanguageID !== event.ID);
      }
      if (name === 'target_languages') {
        this.userData.FavoriteLanguagePaars = this.userData.FavoriteLanguagePaars.filter((item) => item.TargetLanguageID !== event.ID);
      }
      this.addLanguageParams();
    },

    setNewPaars (sLang, tLang) {
      const data = {
        ID: 0,
        IsFavorite: false,
        Selected: false,
        SourceLanguageID: sLang,
        TargetLanguageID: tLang,
        UserId: this.userData.UserId,
      };

      return data;
    },

    changeShowLimit () {
      this.showLimit = 1000000;
      this.showMore = false;
    },

    showInput (event, input) {
      event.target.classList.contains('active') === false ? event.target.classList.add('active') : event.target.classList.remove('active');
      input.disabled = !input.disabled;
      input.focus();
    },

    getAllTitles () {
      return this.$store.dispatch('GET_USER_TITLES').then((data) => {
        this.titles = data;
      });
    },

    getCountries () {
      return this.$store.dispatch('GET_COUNTRIES').then((data) => {
        this.countries = data;
      });
    },

    getLanguages () {
      return this.$store.dispatch('GET_LANGUAGES').then((data) => {
        this.sourceLanguageList = data;
        this.targetLanguageList = data;
      });
    },

    getUserData () {
      return Api.user
        .getProfile()
        .then((response) => {
          this.userData = response.data;
          this.notifacationEmail = this.userData.NotificationEmail;

          if (this.userData.UserCompanyData === null || this.userData.UserCompanyData === undefined) {
            this.userData.UserCompanyData = {
              ID: '',
              Name: '',
              Individual: false,
              TaxNumber: '',
              IndustrySectors: [],
              Status: {},
              ContactNumber: '',
              Notes: '',
            };
          }
        });
    },

    holderUserResponse () {
      this.userData.IndustrySectorIDs = this.userData.IndustrySectorIDs !== null ? this.userData.IndustrySectorIDs.split(',') : null;
      this.userData.Title = this.userData.Title.trim();
      this.userData.Address = this.userData.Address !== null ? JSON.parse(this.userData.Address)[0] : null;
      if (this.userData.Address !== null) {
        this.$set(this.userData.Address, 'Country', this.countries.find((item) => item.ID == parseInt(this.userData.Address.CountryID)));
      }
      this.userData.DocumentTypes = this.userData.DocumentTypes !== null ? JSON.parse(this.userData.DocumentTypes) : null;
      this.userData.CatTools = this.userData.CatTools !== null ? JSON.parse(this.userData.CatTools) : null;
      this.userData.EvaluationMethods = this.userData.EvaluationMethods !== null ? JSON.parse(this.userData.EvaluationMethods) : null;
      this.userData.SourceLanguages = this.userData.SourceLanguages !== null ? JSON.parse(this.userData.SourceLanguages) : null;
      this.userData.TargetLanguages = this.userData.TargetLanguages !== null ? JSON.parse(this.userData.TargetLanguages) : null;

      this.addLanguageParams();
    },

    addLanguageParams () {
      this.userData.FavoriteLanguagePaars.forEach((el) => {
        el.SourceLanguage = this.sourceLanguageList.find((item) => item.ID === el.SourceLanguageID);
        el.TargetLanguage = this.targetLanguageList.find((item) => item.ID === el.TargetLanguageID);
      });
    },

    getIndustryMethods () {
      return this.$store.dispatch('GET_INDUSTRY_TREE').then((data) => {
        this.optionsTree = data;
      });
    },

    getQaMethods () {
      return Api.getEvaluationMethods().then((resp) => {
        this.qaMethodsList = resp.data.Data;
      });
    },

    getDocumentType () {
      return this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
        this.textCategoryList = data;
      });
    },

    getEvaluationMethods () {
      return this.$store.dispatch('GET_QA_METHODS').then((data) => {
        this.evaluationMethodsList = data;
      });
    },

    getCatTools () {
      return Api.getCatTools()
        .then((response) => {
          if (response.data.Status) {
            this.catToolsList = response.data.Data;
          }
        });
    },

    editSave () {
      this.editFile = false;
      const oldFile = this.imgFiles[0];
      const binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1]);
      const arr = new Uint8Array(binStr.length);
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const file = new File([arr], oldFile.name, { type: oldFile.type });
      var reader = new FileReader();

      reader.addEventListener('load', (res) => {
        this.userData.Image = res.srcElement.result;
        this.sendChanges();
      }, false);

      reader.readAsDataURL(file);
    },

    inputFile (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        this.$nextTick(() => {
          this.editFile = true;
        });
      }
      if (!newFile && oldFile) {
        this.editFile = false;
      }
    },

    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.$root.$emit('notification', {
            message: 'Your choice is not a picture',
            type: 'error',
            show: true,
          });
          return prevent();
        }
        if (newFile.size > 5242880) {
          this.$root.$emit('notification', {
            message: `Size file: ${newFile.name} more 5 MB`,
            type: 'error',
            show: true,
          });
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },

    deleteAvatar () {
      this.userData.Image = this.defaultImage;
    },

    trasformParams () {
      const params = Object.assign({}, this.userData);

      for (const [name, value] of Object.entries(params)) {
        if (name === 'SourceLanguages' ||
                    name === 'TargetLanguages' ||
                    name === 'CatTools' ||
                    name === 'DocumentTypes' ||
                    name === 'EvaluationMethods') {
          params[name] = value !== null ? value.map((item) => item.ID).join() : null;
        }
        if (name === 'IndustrySectorIDs') {
          params[name] = value !== null ? value.join() : null;
        }
        if (name === 'QAModels') {
          params['QAModelIds'] = value !== null ? value.map((item) => item.ID).join() : null;
        }
        if (name === 'Address') {
          if (typeof params.Address.Country === 'object') {
            params.Address.CountryID = params.Address.Country.ID;
          }
        }
      }

      params.Address = JSON.stringify(params.Address);

      return params;
    },

    sendChanges () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true;

            Api.user
              .updateProfile(this.trasformParams())
              .then((data) => {
                if (data.data.Status) {
                  this.$parent.$emit('updateUser', true);

                  this.getUserData();

                  this.$root.$emit('notification', {
                    message: 'Profile was updated!',
                    type: 'info',
                    show: true,
                  });
                } else {
                  this.$root.$emit('notification', {
                    message: data.data.Message,
                    type: 'error',
                    show: true,
                  });
                }

                this.loading = false;
              });
          } else {
            this.$root.$emit('notification', {
              message: `${this.errors.items.find((item) => item.field === 'industrySelect').msg} If Individual is unselect.`,
              type: 'error',
              show: true,
            });
          }
        });
    },

    changeNotificationEmail () {
      this.userData.NotificationEmail = this.copyNEmail ? this.user.Email : this.notifacationEmail;
    },
  },
});
